import { create } from 'zustand';

import { ColorTheme } from '@/models/color-theme.ts';

interface ThemeStore {
    theme: ColorTheme;
    reset: () => void;
}

const initialState = {
    theme: ColorTheme.LIGHT,
};

export const useThemeStore = create<ThemeStore>((set) => ({
    ...initialState,
    reset: (): void => set({ ...initialState }),
}));
